import type { FC, ReactElement, ReactNode } from "react";

import {
    StyledIntentBanner,
    StyledIntentBannerContent,
    StyledIntentButtonWrapper,
    StyledIntentContentWithIcon,
    StyledIntentContentWrapper,
    StyledIntentDescription,
    StyledIntentIcon,
    StyledIntentTitle,
} from "./styles";

type Props = {
    className?: string;
    children: ReactElement;
    icon: ReactElement;
    title?: ReactNode;
    description?: ReactNode;
    isVerticalView?: boolean;
    isFullWidth?: boolean;
};

const IntentBanner: FC<Props> = ({
    className,
    children,
    icon,
    title,
    description,
    isVerticalView = false,
    isFullWidth = true,
}) => {
    return (
        <StyledIntentBanner
            className={className}
            isFullWidth={isFullWidth}
        >
            <StyledIntentContentWrapper isVerticalView={isVerticalView}>
                <StyledIntentContentWithIcon isVerticalView={isVerticalView}>
                    <StyledIntentIcon>{icon}</StyledIntentIcon>
                    <StyledIntentBannerContent isVerticalView={isVerticalView}>
                        {title ? <StyledIntentTitle>{title}</StyledIntentTitle> : null}
                        {description ? <StyledIntentDescription>{description}</StyledIntentDescription> : null}
                    </StyledIntentBannerContent>
                </StyledIntentContentWithIcon>
                <StyledIntentButtonWrapper isVerticalView={isVerticalView}>{children}</StyledIntentButtonWrapper>
            </StyledIntentContentWrapper>
        </StyledIntentBanner>
    );
};

export default IntentBanner;
